module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/desktop-app-2-55fc0787db661c5003daf4436431f6db.jpg";